<script>
	import LessonCard from './lesson-card.vue';

	export default{
		mixins: [LessonCard],

		data() {
			return {
				horizontalCard: true
			}
		}
	}
</script>
